import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getUser (id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('users/' + id)
  },
  getUsersList ({limit = 50, page = 1, assigned = false, search}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`, 'sort[]=username']
    if (search) fullRequest.push(`search=${search}`)
    if (assigned) fullRequest.push(`assigned=${assigned}`)
    const address = search ? 'users?' : 'users/withoutelastic?'
    return instCred.get(address + fullRequest.join('&'))
  },
  getUsersListSelect ({
    department = [],
    notUser = '',
    isHrIncluded = false,
    position = []
  }) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        Authorization: `Bearer ${VueCookie.get('token')}`,
        company: VueCookie.get('company')
      }
    })
    const query = []
    if (department.length) query.push(...department)
    if (position.length) query.push(...position)
    if (notUser) query.push(`notUser=${notUser}`)
    if (isHrIncluded) query.push(`isHrIncluded=${isHrIncluded}`)
    return instCred.get(`/user/getSelect?${query.join('&')}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/Users/api.js